module.exports = __webpack_public_path__ + "static/media/office-3.569009e6.jpg";